import moment from 'moment';
import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { handleHttpError } from '../utils/common';
import useAxios from './useAxios';

export interface SubscriberMetricsFansSubscriptionsAndEarningsGroupByMonth {
    year: number;
    month: number;
    dateString: string;
    subsCount: number;
    spendersCount: number;
    amountNet: number;
    messagesCount: number;
    messagesAmountNet: number;
    subscriptionsCount: number;
    subscriptionsAmountNet: number;
    tipsCount: number;
    tipsAmountNet: number;
    postsCount: number;
    postsAmountNet: number;
    streamsCount: number;
    streamsAmountNet: number;
}

const useSextforceMetricsAccountSubscriptionsAndEarningsGroupByMonth = (startDate: Date, endDate: Date, timezone: string) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const dialog = useDialog();
    const params = useParams();
    const axios = useAxios();

    // Fetch Fans Counters
    const fetchReport = async (
        startDate: Date,
        endDate: Date,
        timezone: string,
    ): Promise<SubscriberMetricsFansSubscriptionsAndEarningsGroupByMonth[]> => {
        const query: string = `${settingsContext.routes.metrics.base}${
            params.userId
        }/subscriptionsAndEarningsGroupByMonth?${new URLSearchParams({
            startDate: moment(startDate).toISOString(),
            endDate: moment(endDate).toISOString(),
            timezone,
        })}`;

        const data = await axios
            .get(query)
            .then(async response => response.data)
            .catch(error => {
                console.error(error);
                handleHttpError(error, dialog);

                return [];
            });

        return data;
    };

    return useQuery(
        ['metricsSubscriptionsAndEarningsGroupByMonth', params.userId, startDate, endDate, timezone],
        () => fetchReport(startDate, endDate, timezone),
        {
            refetchOnWindowFocus: false,
            staleTime: 60 * 1000 * 60 * 12,
            enabled: userContext.jwtToken && settingsContext.apiKey && params.userId ? true : false,
        },
    );
};

export default useSextforceMetricsAccountSubscriptionsAndEarningsGroupByMonth;
